
import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator'
import ReviewListItem from '~/components/sections/rating/ReviewListItem.vue'
import ReviewGridItem from '~/components/sections/rating/ReviewGridItem.vue'
import ReviewsPagination from '~/components/sections/rating/ReviewsPagination.vue'
import LoadMoreButton from '~/components/snippets/LoadMoreButton.vue'

type ReviewsDisplayType = 'list' | 'grid'

@Component({
  components: {
    ReviewListItem,
    ReviewGridItem,
    ReviewsPagination,
    LoadMoreButton,
  },
})
export default class ReviewsBox extends Vue {
  @Prop({ required: true })
  readonly reviews!: any

  @Prop({ required: true })
  readonly isLoading!: boolean

  @Prop({ required: true })
  readonly isShowPagination!: boolean

  @Prop({ required: false, default: 'list', type: String })
  private readonly type!: ReviewsDisplayType

  @Prop({ required: false })
  readonly currentPage!: number

  @Prop({ required: false })
  readonly pagesNumber!: number

  get isDisplayTypeList () {
    return this.type === 'list'
  }

  get isDisplayTypeGrid () {
    return this.type === 'grid'
  }

  @Emit('on-pagination-click')
  onPaginationClick () {
    return true
  }

  @Emit('on-pagination-change')
  updateCurrentPage (page: number) {
    return page
  }
}
